import React from "react";
import { IoClose } from "react-icons/io5";
import { MdDone } from "react-icons/md";
import { GoDotFill } from "react-icons/go";

const STYLES = {
  approved: {
    label: "Approved",
    className: "bg-[#ECFDF3] text-[#027A48]",
    Icon: MdDone,
  },
  pending: {
    label: "Pending",
    className: "bg-[#FFF6ED] text-[#FF8D28]",
    Icon: GoDotFill,
  },
  rejected: {
    label: "Cancelled",
    className: "bg-[#FEF3F2] text-[#DC2626]",
    Icon: IoClose,
  },
  "out-of-stock": {
    label: "Out of stock",
    className: "bg-[#F3F4F6] text-[#4B5563]",
    Icon: GoDotFill,
  },
};

export function ApprovalStatusBadge({ status }) {
  const cfg = STYLES[status] ?? STYLES.pending;
  const Icon = cfg.Icon;
  return (
    <span
      className={`inline-flex max-w-full items-center gap-0.5 rounded-full px-2 py-0.5 text-[10px] font-bold sm:gap-1 sm:px-3 sm:py-1 sm:text-[11px] ${cfg.className}`}
    >
      <Icon className="text-[13px] shrink-0" aria-hidden />
      {cfg.label}
    </span>
  );
}
